





























import UserProfileView from "../../components/user/UserProfileView.vue";
import { UserDocumentInfo as IUserDocumentInfo } from "@/api/models/user-document-info";
import { Component, Vue } from "vue-property-decorator";
import api from "@/getinfo-api";
import { getCurrentUserId, isRoot } from "@/plugins/roles";
import { AxiosError } from "axios";
import { User as IUser } from "@/api/models/user";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import { mapGetters } from "vuex";
import CBreadCrumbs from "@/components/form/CustomPage/CBreadCrumbs.vue";

@Component({
  computed: {
    ...mapGetters({
      SELECTED_USER: "SELECTED_USER"
    })
  },
  components: { CBreadCrumbs, UserProfileView }
})
export default class ProfileView extends Vue {
  user!: IUser;
  protected userId?: string;
  SELECTED_USER!: IUser;
  userDocumentInfo!: IUserDocumentInfo;

  data() {
    return {
      user: undefined,
      userId: undefined,
      userDocumentInfo: undefined
    };
  }

  get breadcrumbs() {
    return [
      {
        to: { name: "users" },
        label: this.$tc(this.$translate.Users)
      },
      {
        label: this.$converter.limitedOutput(this.user.fullName, 40)
      }
    ];
  }

  get userCanEditProfile() {
    return this.root || this.currentUserId === this.userId;
  }

  get root() {
    return isRoot();
  }

  get currentUserId() {
    return getCurrentUserId();
  }

  getDocumentInformation() {
    api.UsersApi.getDocumentInfo(this.$route.params.id)
      .then((res: { data: IUserDocumentInfo }) => {
        this.userDocumentInfo = res.data;
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  created() {
    this.getDocumentInformation();
  }

  mounted() {
    if (this.SELECTED_USER.id === this.$route.params.id) {
      this.user = this.SELECTED_USER;
      this.userId = this.$route.params.id;
      document.title = `${this.user.fullName}`;
    } else {
      this.userId = this.$route.params.id;
      api.UsersApi.get(this.userId)
        .then(res => {
          this.user = res.data;
          document.title = `${this.user.fullName}`;
        })
        .catch(() => {
          this.$bvToast.toast(
            this.$tc(this.$translate.UnableToRetrieveUserInformation),
            {
              variant: "danger",
              title: this.$tc(this.$translate.Error)
            }
          );
        });
    }
  }
}
